export const EVENTS = {
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  REMOVE_FROM_CART: "remove_from_cart",
  VIEW_CART: "view_cart",
  SELECT_ITEM: "select_item",
  VIEW_ITEM_LIST: "view_item_list",
  BEGIN_CHECKOUT: "begin_checkout",
  ADD_SHIPPING_INFO: "add_shipping_info",
  CC_PAYMENT: "cc_payment",
  AFF_SELECTED: "aff_selected",
  AFF_MONTHLY_PAYMENT: "aff_monthly_payment",
  ACCEPT_SERVICE_TERMS: "accept_service_terms",
  PURCHASE: "purchase",
  PDP_PRODUCT_SEARCH: "pdp_product_search",
  BYO_CONFIGURATOR_INTERACTION: "byo-configurator-interaction",
  FORM_SUBMIT_COMPLETE: "submit-complete",
  FORM_SUBMIT_ATTEMPT: "submit-attempt",
  FORM_SUBMIT_FAILURE: "submit-failure",
  FORM_SUBMIT_PRE_API_CALL: "form-submit-pre-api-call",
  SIERRA_CHAT_EVENT: "sierra_chat_event",
};

export const FLOW_TYPE = {
  BLU_DIY: "blu_diy",
  PARTNER: "partner",
};

export const FLOW_TYPE_PARTNER = {
  ADT_QUIZ: "adt-quiz",
  ADT: "adt",
};

export const PAGE = {
  BLU_PLP: "blu_plp",
  BLU_PDP: "blu_pdp",
};

export const EVENT_TYPES = {
  ENGAGEMENT: "engagement",
  RECOMMENDATION: "recommendation",
  TRANSFER: "transfer",
};

export const DEFAULT_ECID = "default";

export type TrafficChannel = "DIRECT" | "SEO" | "REFERRED" | "SOCIAL";

export const SOCIAL_SITE_LIST =
  "[www.facebook.com, www.twitter.com, www.nextdoor.com, www.linkedin.com, www.pinterest.com, reddit.com, instagram.com, yelp.com, com.linkedin, m.facebook, blogspot.com, zhihu.com, ampproject.org, pinterest.ch, twitter.com, yelp.co.uk, last.fm, yelp.com.ph, lnkd.in, pinterest.ca, vk.com, disqus.com, t.co, tiktok.com, snapchat.com, l.facebook.com, m.facebook.com, lm.facebook.com, l.instagram.com]";

export const SEO_SITE_LIST =
  "[www.google.com, bing.com, yahoo.com, google.ca, google.co.uk, com.google, duckduckgo.com, google.co.in, baidu.com, google.co.in, baidu.com, ask.com, google.com.au, google.co.za, google.com.hk, google.ie, google.com.ph, google.com.pr, google.de, myway.com, google.com.mx, google.com.pk, google.com.sg, google.co.nz, google.com.tw, google.fr, google.es, google.nl, google.it, google.com.br, google.ae, google.co.kr, google.co.jp, google.se, google.be, google.com.ar, google.com.ua, google.com.vn, google.co.il, google.com.sa, google.gr, google.co.th, google.com.tr, google.ru, google.com.co, google.ch, google.pl, google.com.my, google.co.id, google.com.ng, google.com.eg, ecosia.org, maps.google.com, google.coalerts.com, aol.com, m.baidu.com, qwant.com, yandex.com, yandex.ru, dogpile.com]";
